import { type RefObject } from "react";
import { AlertCircle } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import type { StoryStatus } from "@/lib/types";

interface CanvasProps {
  iframeRef: RefObject<HTMLIFrameElement | null>;
  iframeSrc: string;
  status: StoryStatus;
  storyId: string | undefined;
}

const hasFailure = (status: StoryStatus): boolean =>
  Boolean(status.error) || status.playStatus === "failed";

export const Canvas = ({ iframeRef, iframeSrc, status, storyId }: CanvasProps) => {
  if (!storyId) {
    return (
      <div className="flex h-full items-center justify-center bg-background text-sm text-muted-foreground">
        Select a story from the sidebar.
      </div>
    );
  }

  return (
    <div className="relative flex h-full flex-col bg-background">
      <div className="flex-1 overflow-hidden bg-muted/30">
        <iframe
          ref={iframeRef}
          src={iframeSrc}
          title={storyId}
          className={cn("h-full w-full border-0")}
        />
      </div>
      {hasFailure(status) ? (
        <div className="pointer-events-none absolute right-3 top-3">
          <Badge variant="destructive" className="pointer-events-auto">
            <AlertCircle className="h-3 w-3" />
            {status.error ? "Error" : "Play failed"}
          </Badge>
        </div>
      ) : null}
    </div>
  );
};
